import { PkgStatus, UserPkg } from '@/api/user-package/types/UserPkg'

export const getPkgStatus = (pkg: UserPkg) => {
  if (pkg.isShipped) return 'נשלחה'
  if (pkg.status === PkgStatus.NeedId) return 'נדרש זיהוי'
  if (pkg.isPaid && !pkg.isShipped) return 'ממתין למשלוח'
  if (pkg.isReturnRequestActive) return 'ממתין להחזרה'
  if (pkg.isPhotoRequestActive || pkg.isShrinkRequestActive || pkg.isUniteRequestActive) return 'בקשה ממתינה לביצוע'
  return 'מוכנה למשלוח'
}
